module.exports = ".row{\r\n    padding:2px 0px 0px;\r\n} \r\n\r\n/* .row:nth-child(odd){\r\n    background: #f3f3f3;\r\n} */ \r\n\r\n.form-inline label {\r\n    color:  #45738a;\r\n} \r\n\r\n.section{\r\n    border-right: 1px solid red;\r\n} \r\n\r\n.martop20{\r\n    margin-top: 20px;\r\n} \r\n\r\ntr td{\r\n    color:#45738a;\r\n    font-weight: 600;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/home-is-department/home-is-department.component.css
// module id = ./src/app/pages/home/home-is-department/home-is-department.component.css
// module chunks = main